<template>
    <div class="block">
        <p v-if="label" class="text-gray-800 text-sm">
            {{ label }}
        </p>
        <div
            class="flex overflow-hidden bg-gray-50 rounded border border-gray-300"
            :class="{ 'bg-gray-200': disabled, 'border-lightblue-500': inputFocused, 'border-red-500': errors.length }"
        >
            <textarea
                class="h-32 flex-grow border-0 bg-gray-50 outline-0 focus:ring-0"
                :class="{ 'bg-gray-200 text-gray-500': disabled, 'border-red-500': errors.length }"
                :disabled="disabled"
                :value="modelValue"
                :placeholder="placeholder"
                @input="$emit('update:modelValue', $event.target.value)"
                @focus="inputFocused = true"
                @blur="inputFocused = false"
            />
        </div>
        <ul v-if="errors.length">
            <li v-for="(error, index) in errors" :key="index" class="text-red-500 text-xs">
                {{ error }}
            </li>
        </ul>
    </div>
</template>

<script>
import { ref } from "vue";

export default {
    name: "TextAreaInput",
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        errors: {
            type: Array,
            required: false,
            default: () => [],
        },
        label: {
            type: String,
            required: false,
            default: "",
        },
        modelValue: {
            type: String,
            required: true,
        },
        placeholder: {
            type: String,
            required: false,
            default: "",
        },
    },
    emits: ["update:modelValue"],
    setup() {
        const inputFocused = ref(false);

        return {
            inputFocused,
        };
    },
};
</script>
